export default __webpack_public_path__ + "static/media/bg_round.560620f0.svg";